export const NEW_REQUEST_CTA = `הגשת בקשה חדשה`;
